
function GetRegister(clashBotData, setClashBotData, setRegister) {

  clashBotData.sort((a,b) => {
    if(a.week < b.week) return -1;
    if(a.week === b.week && a.type < b.type) return -1;
    return 0;
  })

  _createRegister(clashBotData, setClashBotData, setRegister);
}

export default GetRegister;



const _createRegister = (clashBotData, setClashBotData, setRegister) => {

  var register = [];

  clashBotData.forEach((project, p) => {
    project.roles.forEach((role, r) => {
      if(role.cast !== true) {

        // Move each choice up so that the highest is at position 0
        var shift = 0;
        role.choices.forEach((choice, c) => {
          if(choice === null) shift += 1;
          else if(shift !== 0) {
            const temp = choice;
            role.choices[c] = null;
            role.choices[c - shift] = temp;
          }
        })

        const top_auditionee_id = role.choices[0];

        /*
        * If the first choice isn't null (i.e. the role still has >= 1 option(s) available), 
        * compare it to all other registered first choices to find any direct clashes.
        */ 
        if(top_auditionee_id !== null)
        {
          var isDirectClash = false;

          register.every((entry) => {
            // Checks if the current entry is the same as the one currently being checked (stops auditionees clashing with their same entry for the same role)
            const isSameCurrentChoice = entry.current_choices.includes({project_index: p, role_index: r});

            if(entry.auditionee_id === top_auditionee_id && !isSameCurrentChoice)
            {
              // This is a direct clash
              entry.current_choices.push({
                project_index: p,
                role_index: r
              })

              isDirectClash = true;
              return false;
            }
            return true;
          })

          // If there are no direct clashes thus far, add the auditionee to the register
          if(isDirectClash === false)
          {
            register.push({
              auditionee_id: top_auditionee_id,
              current_choices: [{
                project_index: p,
                role_index: r
              }],
              potential_clash: false,
              ghost_clash: false,
              potential_clashes: [],
              ghost_clashes: [],
            })
          }

        }

      }
    })
  })

  setClashBotData(clashBotData);

  register = _addPotentialAndGhostClashes(clashBotData, register);
  const finalRegister = _getSortedRegister(register)
  setRegister(finalRegister);

}


/**
 * CONST FOR CREATING THE SORTED REGISTER 
 * D = Direct Clash
 * P = Potential Clash
 * G = Ghost Clash
 * 
 * Names are sorted into groups in the order
 * 1.   D
 * 2.   D ^ G
 * 3.   D ^ P
 * 4.   D ^ P ^ G
 * 5.   P
 * 6.   P ^ G
 * 7.   [!D^!P^!G]
 * 8.   G
 */
function _getSortedRegister(register) {

  return [...register].sort((a, b) => {
    function getPriority(person) {
      const d = person.current_choices.length > 1;
      const p = person.potential_clash;
      const g = person.ghost_clash;

      if(  d  &&  !p  &&  !g   ) return 1;
      if(  d  &&  !p  &&   g   ) return 2;
      if(  d  &&   p  &&  !g   ) return 3;
      if(  d  &&   p  &&   g   ) return 4;
      if( !d  &&   p  &&  !g   ) return 5;
      if( !d  &&   p  &&   g   ) return 6;
      if( !d  &&  !p  &&  !g   ) return 7;
      return 8;
    }

    const priorityA = getPriority(a);
    const priorityB = getPriority(b);

    if(priorityA !== priorityB) return priorityA - priorityB;

    return b.current_choices.length - a.current_choices.length;
  })

}


/*
  BEHIND THE SCENES, THERE ARE THREE KINDS OF CLASHES
  Direct Clash = Person is first choice for more than one role
  Potential Clash = Person is first choice for >=1 role, and second choice behind another direct clash
  Ghost Clash = Person is first choice for >= 1 role, and second choice behind a non-clashing first choice
*/
const _addPotentialAndGhostClashes = (clashBotData, register) => {

  register.forEach((a) => {
    a.current_choices.forEach(choice => {
      const nextChoice = clashBotData[choice.project_index].roles[choice.role_index].choices[1];
      if(nextChoice !== null)
      {
        register.forEach((b) => {
          if(b.auditionee_id === nextChoice)
          {
            if(a.current_choices.length > 1)
            {
              b.potential_clash = true;
              b.potential_clashes.push({
                project_index: choice.project_index,
                role_index: choice.role_index
              })
            }
            else {
              b.ghost_clash = true;
              b.ghost_clashes.push({
                project_index: choice.project_index,
                role_index: choice.role_index
              })
            }
          }
        })
      }
    })
  })

  return register;

}